import { mapTypenameToResourceType } from "shared/api/serializer/mapTypenameToAPIType"
import {
  FloorTypename,
  ProductPositionTypename,
  ProjectTypename,
  RoomTypename
} from "shared/types/Project"

import { useAttachmentsByShareLinkQuery as useAttachmentsByShareLinkQueryGenerated } from "../graphql/project-attachments.queries.generated"

type AttachmentResourceTypename =
  | typeof ProjectTypename
  | typeof FloorTypename
  | typeof RoomTypename
  | typeof ProductPositionTypename

interface AttachmentsByShareLinkQueryArgs {
  id: string
  resourceType: AttachmentResourceTypename
  projectShareID: string
  skip?: boolean
}

export function useAttachmentsByShareLinkQuery({
  id,
  resourceType,
  projectShareID,
  skip
}: AttachmentsByShareLinkQueryArgs) {
  return useAttachmentsByShareLinkQueryGenerated({
    variables: {
      projectShareID,
      id,
      type: mapTypenameToResourceType(resourceType) ?? ""
    },
    skip
  })
}
